import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Wraps page content with a brief motion-blur + opacity fade-in
 * whenever the route changes. Re-mounts on `key={pathname}`.
 */
export const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Restart the animation on every pathname change
    el.classList.remove("page-enter");
    // force reflow so animation can re-trigger
    // eslint-disable-next-line no-unused-expressions
    el.offsetWidth;
    el.classList.add("page-enter");
  }, [pathname]);

  return (
    <div ref={ref} className="page-enter" key={pathname}>
      {children}
    </div>
  );
};

export default PageTransition;
